import { render, staticRenderFns } from "./RewardsIcon.vue?vue&type=template&id=733c2c5a&scoped=true&"
import script from "./RewardsIcon.vue?vue&type=script&lang=js&"
export * from "./RewardsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733c2c5a",
  null
  
)

export default component.exports